import React, { Component } from "react";
import "./Comment.css";

class Comment extends Component {
  render() {
    return (
      <div className="comment-border">
        <div className="comment">
          <div className="comment-header">
            <span className="comment-author">{this.props.author}</span>
            <br />
            <span className="comment-created">{this.props.createdAtFormatted}</span>
          </div>
          <span className="comment-body">{this.props.body}</span>
        </div>
      </div>
    );
  }
}

export default Comment;
